import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function MigrationPage() {
  const [status, setStatus] = useState('');
  const [logs, setLogs] = useState([]);
  const [isRunning, setIsRunning] = useState(false);
  const navigate = useNavigate();

  const addLog = (message) => {
    setLogs(prev => [...prev, message]);
  };

  const runMigration = async () => {
    setIsRunning(true);
    setStatus('🚀 Migrazione in corso...');
    setLogs([]);

    try {
      addLog('📡 Recupero wishlists dal database...');
      
      let totalWishlists = 0;
      let totalProducts = 0;
      let convertedProducts = 0;

      const wishlistsSnapshot = await getDocs(collection(db, 'wishlists'));
      totalWishlists = wishlistsSnapshot.size;
      
      addLog(`📊 Trovate ${totalWishlists} wishlists da processare`);

      for (const wishlistDoc of wishlistsSnapshot.docs) {
        const wishlistData = wishlistDoc.data();
        const products = wishlistData.products || [];
        
        if (products.length === 0) continue;
        
        totalProducts += products.length;
        let modified = false;

        const updatedProducts = products.map(product => {
          if (product.image && typeof product.image === 'string' && product.image.startsWith('http://')) {
            const httpsImage = product.image.replace('http://', 'https://');
            addLog(`🔒 Convertito: ${product.title?.substring(0, 40)}...`);
            convertedProducts++;
            modified = true;
            return { ...product, image: httpsImage };
          }
          return product;
        });

        if (modified) {
          await updateDoc(doc(db, 'wishlists', wishlistDoc.id), {
            products: updatedProducts
          });
          addLog(`✅ Aggiornata wishlist: ${wishlistData.name}`);
        }
      }

      addLog('');
      addLog('🎉 MIGRAZIONE COMPLETATA!');
      addLog(`📊 Statistiche:`);
      addLog(`   - Wishlists totali: ${totalWishlists}`);
      addLog(`   - Prodotti totali: ${totalProducts}`);
      addLog(`   - Convertiti HTTP → HTTPS: ${convertedProducts}`);
      addLog(`   - Già sicuri (HTTPS/data): ${totalProducts - convertedProducts}`);
      addLog('');
      addLog('✅ Tutte le immagini sono ora compatibili con iOS!');
      addLog('🔄 Ricarica l\'app iOS per vedere le modifiche.');

      setStatus(`✅ Completata! Convertite ${convertedProducts} immagini.`);

    } catch (error) {
      console.error('Errore migrazione:', error);
      addLog(`❌ Errore: ${error.message}`);
      setStatus('❌ Migrazione fallita. Vedi i log per dettagli.');
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div style={{
      maxWidth: '800px',
      margin: '50px auto',
      padding: '30px',
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <h1 style={{ marginBottom: '10px' }}>🔒 Migrazione HTTP → HTTPS</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>
        Converti tutte le immagini dei prodotti da HTTP a HTTPS per la compatibilità iOS
      </p>

      <button
        onClick={runMigration}
        disabled={isRunning}
        style={{
          background: isRunning ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: isRunning ? 'not-allowed' : 'pointer',
          fontSize: '16px',
          fontWeight: '600',
          marginRight: '10px'
        }}
      >
        {isRunning ? 'Migrazione in corso...' : 'Avvia Migrazione'}
      </button>

      <button
        onClick={() => navigate('/')}
        style={{
          background: '#6c757d',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '600'
        }}
      >
        Torna alla Home
      </button>

      {status && (
        <div style={{
          marginTop: '20px',
          padding: '15px',
          borderRadius: '6px',
          background: status.includes('✅') ? '#d4edda' : status.includes('❌') ? '#f8d7da' : '#e7f3ff',
          border: `1px solid ${status.includes('✅') ? '#c3e6cb' : status.includes('❌') ? '#f5c6cb' : '#b3d7ff'}`
        }}>
          {status}
        </div>
      )}

      {logs.length > 0 && (
        <div style={{
          marginTop: '20px',
          padding: '15px',
          background: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '6px',
          maxHeight: '400px',
          overflowY: 'auto',
          fontFamily: 'Courier New, monospace',
          fontSize: '13px'
        }}>
          {logs.map((log, index) => (
            <div key={index}>{log}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MigrationPage;
